import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ADVOCATES_PSF = createFcmDetails('advocates_psf', {
	owner: 'Narwhal Squad',
	context: 'Advocates PSF',
	description: 'Enables and disables the Advocates PSF flow',
	import: false,
});
